import React from 'react'
import {
  Col,
  Row,
  Tabs,
  Link,
  ShareIcon,
  CaptionText,
} from '@paypalcorp/pp-react'
import { Message, injectWorldReady } from '@paypalcorp/worldready-react'

import { recordDynamicEvent } from '../../../components/common/analytics/utils'
import MostPopular from './payment-solutions-tabs/most-popular'
import Online from './payment-solutions-tabs/online'
import Payouts from './payment-solutions-tabs/payouts'
import MultiParty from './payment-solutions-tabs/multi-party'
import { saveBannerProgress } from '../../../utils/session-utils'
import { useApplicationContext } from '../../../context/ApplicationContext'
import { useMessage } from '../../../hooks'

function PaymentSolutions({
  setBannerPage,
  setProductIntegration,
  tabIndex,
  setTabIndex,
  setCurrentBannerStep,
}) {
  const { csrf, logger } = useApplicationContext()
  const localizedMsg = useMessage()

  function switchTabIndex(index) {
    setTabIndex(index)
  }

  return (
    <>
      <Row>
        <Col md={10} lg={10} xl={10}>
          <CaptionText className="caption-ob-subtitle">
            <Message
              id="onboarding-banner.paymentSolutionHelperText"
              className="caption-payment-solution-subtitle"
            />{' '}
            <Link
              size="md"
              onClick={() => {
                recordDynamicEvent('onboarding_banner,click,skip_step')

                const sessionObject = {
                  bannerPage: 2,
                }
                saveBannerProgress(csrf, logger, sessionObject)
                setBannerPage(2)
                setCurrentBannerStep(sessionObject)
              }}
            >
              <Message id="onboarding-banner.paymentSolutionHelperTextLink" />
            </Link>
          </CaptionText>
        </Col>
      </Row>
      <Row>
        <Col xs={10} />
        <Col xs={2}>
          <Link
            target="_blank"
            href="https://developer.paypal.com/docs/online"
            data-dxa="onboarding_banner,click,all_products"
            className="onboarding-banner_all-products"
          >
            <Message id="onboarding-banner.payment-solutions.allProducts" />
            <ShareIcon size="xs" />
          </Link>
        </Col>
      </Row>
      <Row>
        <Col>
          <Tabs
            name="TabsGroup4"
            selectedTabIdx={tabIndex}
            tabs={[
              {
                label: localizedMsg('onboarding-banner.tabOne.title'),
                id: 'group4-tab1',
                panelId: 'group4-panel1',
              },
              {
                label: localizedMsg('onboarding-banner.tabTwo.title'),
                id: 'group4-tab2',
                panelId: 'group4-panel2',
              },
              {
                label: localizedMsg('onboarding-banner.tabThree.title'),
                id: 'group4-tab3',
                panelId: 'group4-panel3',
              },
              {
                label: localizedMsg('onboarding-banner.tabFour.title'),
                id: 'group4-tab4',
                panelId: 'group4-panel4',
              },
            ]}
            onClick={(e, index) => {
              switchTabIndex(index)
              recordDynamicEvent(`onboarding_banner_tabs,click,${index}`)
            }}
            className="tabgroup-onboarding_banner"
          >
            <MostPopular
              setBannerPage={setBannerPage}
              setProductIntegration={setProductIntegration}
            />
            <Online
              setBannerPage={setBannerPage}
              setProductIntegration={setProductIntegration}
            />
            <Payouts
              setBannerPage={setBannerPage}
              setProductIntegration={setProductIntegration}
            />
            <MultiParty
              setBannerPage={setBannerPage}
              setProductIntegration={setProductIntegration}
            />
          </Tabs>
        </Col>
      </Row>
    </>
  )
}

export default injectWorldReady(PaymentSolutions)
